/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PartnerIntentRequest } from "./PartnerIntentRequest";

/**
 * Request body for POST /affiliate.
 */
export interface AffiliateRequest {
  /** If provided, /affiliate targets this partner directly. Otherwise it performs a broad match-and-claim across all partners. */
  partner_intent?: PartnerIntentRequest | null;
}
